import { BaseApi } from './_base.api'
import { IPaymentFormData } from '@typings'

export class PaymentApi extends BaseApi {
  /**
   * Get all payments for a document
   */
  getPayments = (documentId: number) => this.api.get(`/documents/${documentId}/payments`).then(res => res.data.data)

  /**
   * Get a single payment
   */
  getPayment = (documentId: number, paymentId: number) =>
    this.api.get(`/documents/${documentId}/payments/${paymentId}`).then(res => res.data.data)

  /**
   * Record a new payment
   */
  createPayment = (documentId: number, data: IPaymentFormData) =>
    this.api.post(`/documents/${documentId}/payments`, data).then(res => res.data.data)

  /**
   * Update a payment
   */
  updatePayment = (documentId: number, paymentId: number, data: Partial<IPaymentFormData>) =>
    this.api.put(`/documents/${documentId}/payments/${paymentId}`, data).then(res => res.data.data)

  /**
   * Delete a payment
   */
  deletePayment = (documentId: number, paymentId: number) =>
    this.api.delete(`/documents/${documentId}/payments/${paymentId}`).then(res => res.data.data)
}
